export default class Card {

    constructor(id, section, translations, medias, questions){
        this.id = id;
        this.section = section;       
        this.translations = translations;
        this.medias = medias;
        this.questions = questions;
    }

    getId(){
        return this.id;
    }

    getSection(){
        return this.name;
    }

    getTranslations(){
        return this.translations;
    }

    getMedias(){
        return this.medias;
    }

    getQuestions(){
        return this.questions;
    }

    setId(id){
        this.id = id;
    }

    setSection(section){
        this.section = section;
    }

    setTranslation(translations){
        this.translations = translations;
    }

    setMedias(medias){
        this.medias = medias;
    }

    setQuestions(questions){
        this.questions = questions;
    }
}